import { render, staticRenderFns } from "./AllInfrastructure.vue?vue&type=template&id=01e64c0a"
import script from "./AllInfrastructure.vue?vue&type=script&lang=js"
export * from "./AllInfrastructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports